import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import { BrowserRouter } from 'react-router-dom';

import stores from './stores';
import App from './App';

import './assets/css/index.css';

ReactDOM.render(
  <BrowserRouter basename="/">
    <Provider {...stores}>
      <App />
    </Provider>
  </BrowserRouter>
, document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js